import {ChangeDetectionStrategy, Component, input, output, signal} from '@angular/core';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {ProjectReferenceScoreView} from '@frontend/shared-api';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {QuestionnaireTabContentComponent} from '../../questionnaire-tab-content/questionnaire-tab-content.component';
import {BadgeListItem} from '../../../list/badge-list/badge-list.types';
import {
  AttributeValueChange,
  SubcriteriaRenderer,
  SubcriteriaTab,
} from '../../provider-questionnaire.types';
import {TabStatusEnum} from '../../../../tabs/tab-status.model';
import {TabPanelComponent} from '../../../../tabs/tab-panel/tab-panel.component';
import {TabStatusDirective} from '../../../../tabs/tab-status.directive';
import {TabsUnsavedRevealDirective} from '../../../../tabs/tabs-unsaved-reveal.directive';
import {ProjectReferencesComponent} from '../../project-references/project-references.component';
import {NoDataComponent} from '../../../no-data/no-data.component';

@Component({
  selector: 'app-questionnaire-standard-tabs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Tab,
    TabList,
    Tabs,
    TabPanels,
    TabPanel,
    TabPanelComponent,
    QuestionnaireTabContentComponent,
    TranslateDirectusPipe,
    TabStatusDirective,
    TabsUnsavedRevealDirective,
    ProjectReferencesComponent,
    NoDataComponent,
  ],
  templateUrl: './questionnaire-standard-tabs.component.html',
})
export class QuestionnaireStandardTabsComponent {
  protected readonly SubcriteriaRenderer = SubcriteriaRenderer;

  subcriteriaTabs = input.required<SubcriteriaTab[]>();
  activeScTabIndex = input.required<number>();
  scTabCompletionStatus = input.required<TabStatusEnum[]>();
  scTabsUnsaved = input<boolean[]>([]);
  badgeListItems = input.required<BadgeListItem[]>();
  canSave = input.required<boolean>();
  isSaving = input.required<boolean>();
  disabled = input<boolean>(false);
  showImportanceScore = input<boolean>(true);
  toolId = input<number | undefined>();
  projectReferenceScores = input<ProjectReferenceScoreView[]>([]);
  projectReferencesReadOnly = input<boolean>(false);

  scTabChange = output<number>();
  projectReferencesSavedCountChange = output<number>();
  projectReferencesUnsavedChange = output<boolean>();
  attributeValueChange = output<AttributeValueChange>();
  saveClick = output<void>();

  protected readonly isProjectReferencesLoading = signal<boolean>(false);
}
